import type { SVGProps } from "react";
import * as React from "react";

const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 19a1 1 0 1 0 2 0zm1-14 .707-.707a1 1 0 0 0-1.414 0zm-7.707 6.293a1 1 0 1 0 1.414 1.414zm14 1.414a1 1 0 0 0 1.414-1.414zM13 19V5h-2v14zm-7.293-6.293 7-7-1.414-1.414-7 7zm5.586-7 7 7 1.414-1.414-7-7z"
    />
  </svg>
);
export default SvgArrowUp;
